import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const UpdatePaymentMethodForm = ({ onCancel, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);
    setMessage(null);

    const { error } = await stripe.confirmSetup({
      elements,
      redirect: 'if_required', // This prevents a full-page redirect
    });

    if (error) {
      setMessage(error.type === "card_error" || error.type === "validation_error" ? error.message : "An unexpected error occurred.");
      setIsProcessing(false);
    } else {
      // The SetupIntent was successful. The webhook will handle updating the customer.
      setIsSuccess(true);
      setMessage("Your payment method has been updated successfully!");
      // Call the onSuccess callback after a short delay to let the user read the message.
      setTimeout(() => {
        onSuccess();
      }, 2500);
    }
  };

  const messageStyles = (isError) => 
    `mt-4 p-3 rounded-md text-center text-sm ${isError ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`;
  
  const buttonStyles = "px-4 py-2 text-sm font-medium rounded-md text-white transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed";

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <div className="flex items-center justify-end gap-2 mt-4">
        <button type="button" onClick={onCancel} disabled={isProcessing} className={`${buttonStyles} bg-gray-500 hover:bg-gray-600`}>
          Cancel
        </button>
        <button disabled={isProcessing || !stripe || !elements} className={`${buttonStyles} bg-green-600 hover:bg-green-700`}>
          {isProcessing ? "Saving..." : "Save Card"}
        </button>
      </div>
      {message && <div className={messageStyles(!isSuccess)}>{message}</div>}
    </form>
  );
};

export default UpdatePaymentMethodForm;